<div style="display: block;height: 300px;">
    <app-highcharts chartTitle="Bytes/segundo" [data$]="dataSubject" height="300" ></app-highcharts>
</div>
